import React, { useState } from 'react';
import './ContactForm.css';

export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    phone: '',
    address: '',
  });

  const [status, setStatus] = useState(null);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const response = await fetch('https://api.itosoba.ru/send-email', { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok && result.status === 'success') {
        alert(`Спасибо за сообщение, ${formData.name}!`);
        setFormData({ name: '', email: '', message: '', phone: '', address: '' });
        setStatus('success');
      } else {
        alert('Ошибка при отправке сообщения. Попробуйте позже.');
        setStatus('error');
      }
    } catch (e) {
      alert('Сервис временно недоступен. Попробуйте позже.');
      setStatus('error');
    }
  };

  return (
      <form
          id="contact-form"
          className="contact-form"
          onSubmit={handleSubmit}
      >
        <h2>Свяжитесь с нами</h2>

        <label>
          Имя:<br/>
          <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Ваше имя"
              required
          />
        </label>

        <label>
          Номер телефона:<br/>
          <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Ваш номер телефона"
              required
          />
        </label>

        <label>
          Email:<br/>
          <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Ваш email"
              required
          />
        </label>

        <label>
          Адрес:<br/>
          <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Ваш адрес"
          />
        </label>

        <label>
          Сообщение:<br/>
          <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Ваше сообщение"
              required
              rows={5}
          />
        </label>

        <button type="submit">Отправить</button>
      </form>
  );
}